
function listenOpen() {
    var checkbox = document.getElementById('nav-toggle');
    var menu = document.getElementById('menu-container');
    var navList = document.getElementById('nav-list');

    if (checkbox) {
        checkbox.addEventListener('change', function() {
            if (checkbox.checked) {
                bodyScrollLock.disableBodyScroll(navList);
                menu.classList.add('menu-container--is-open');
            } else {
                bodyScrollLock.enableBodyScroll(navList);
                menu.classList.remove('menu-container--is-open');
            }
        });
    }
}

function handleUserMenu() {
    var input = document.getElementById('user-menu-toggle');
    var userMenu = document.getElementById('user-menu');
    var menu = document.getElementById('menu-container');

    if (input && menu && userMenu) {
        input.addEventListener('change', function() {
            if (input.checked) {
                menu.classList.add('menu-container--user-menu-open');
                //disableBodyScroll(userMenu);
            } else {
                menu.classList.remove('menu-container--user-menu-open');
                //enableBodyScroll(userMenu);
            }
        });
    }
}

function togglePassword() {
    var toggleList = document.querySelectorAll('.js-toggle-password');

    if (toggleList.length > 0) {
        toggleList.forEach(function(toggle) {
            toggle.addEventListener('click', function() {
                var input = toggle.closest('.form-container').querySelector('input');
                var isVisible = input.type === 'text';

                if (!isVisible) {
                    input.type = 'text';
                    toggle.classList.add('visible');
                } else {
                    input.type = 'password';
                    toggle.classList.remove('visible');
                }
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', function () {
    listenOpen();
    handleUserMenu();
    togglePassword();
});
